import { useReducer, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import { ContractModalBody } from "./contractmodalbody";
import { initialState, reducer } from "./contractreducer";

// NewContractModal
export default function ContractModal({ contract, onCancel, onSave, checkPersonNumber, personNumberCheckResult, actionType, onFormErrors, setPdf }) {
  const reduxDispatch = useDispatch();
  const clearContractDetails = useCallback( () => reduxDispatch({type: "CLEAR_CONTRACT_DETAILS"}) );

  const { t } = useTranslation();

  const [ state, dispatch ] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({type: "initialState"});
    return clearContractDetails; // cleanup
  }, [contract]);

  function handleSave() {
    onSave(state);
  }

  return (
    <ContractModalBody
      show
      state={state}
      dispatch={dispatch}
      title={t("NewContract", "Uusi työsopimus")}
      handleSave={handleSave}
      handleCancel={onCancel}
      checkPersonNumber={checkPersonNumber}
      personNumberCheckResult={personNumberCheckResult}
      actionType={actionType}
      onFormErrors={onFormErrors}
      setPdf={setPdf}
    />
  );
}
